import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MenuIcon, XIcon, UserIcon, LogOutIcon, HomeIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };
  return <header className="bg-[#006D77] text-white shadow-md sticky top-0 z-50" data-id="element-555">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-556">
        <Link to="/" className="flex items-center space-x-2" data-id="element-557">
          <HomeIcon className="h-8 w-8 text-[#D4A017]" data-id="element-558" />
          <span className="font-bold text-xl md:text-2xl" data-id="element-559"> Minayo </span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6" data-id="element-560">
          <Link to="/" className="hover:text-[#D4A017] transition-colors" data-id="element-561">
            Home
          </Link>
          <Link to="/search" className="hover:text-[#D4A017] transition-colors" data-id="element-562">
            Find Stays
          </Link>
          {user ? <div className="relative group" data-id="element-563">
              <button className="flex items-center space-x-2 hover:text-[#D4A017]" data-id="element-564">
                <span data-id="element-565">{user.name}</span>
                <UserIcon className="h-5 w-5" data-id="element-566" />
              </button>
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 hidden group-hover:block" data-id="element-567">
                <Link to="/dashboard" className="block px-4 py-2 text-[#333333] hover:bg-[#F8F5F0]" data-id="element-568">
                  Dashboard
                </Link>
                <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-[#333333] hover:bg-[#F8F5F0]" data-id="element-569">
                  Sign out
                </button>
              </div>
            </div> : <Link to="/auth" className="bg-[#D4A017] hover:bg-[#c29316] text-white px-4 py-2 rounded-md transition-colors" data-id="element-570">
              Sign In
            </Link>}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={toggleMenu} data-id="element-571">
          {isMenuOpen ? <XIcon className="h-6 w-6 text-white" data-id="element-572" /> : <MenuIcon className="h-6 w-6 text-white" data-id="element-573" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-[#006D77] py-4" data-id="element-574">
          <div className="container mx-auto px-4 flex flex-col space-y-3" data-id="element-575">
            <Link to="/" className="block py-2 hover:text-[#D4A017]" onClick={() => setIsMenuOpen(false)} data-id="element-576">
              Home
            </Link>
            <Link to="/search" className="block py-2 hover:text-[#D4A017]" onClick={() => setIsMenuOpen(false)} data-id="element-577">
              Find Stays
            </Link>
            {user ? <>
                <Link to="/dashboard" className="block py-2 hover:text-[#D4A017]" onClick={() => setIsMenuOpen(false)} data-id="element-578">
                  Dashboard
                </Link>
                <button onClick={handleLogout} className="flex items-center py-2 hover:text-[#D4A017] text-left" data-id="element-579">
                  <LogOutIcon className="h-5 w-5 mr-2" data-id="element-580" />
                  Sign out
                </button>
              </> : <Link to="/auth" className="bg-[#D4A017] hover:bg-[#c29316] text-white px-4 py-2 rounded-md transition-colors inline-block" onClick={() => setIsMenuOpen(false)} data-id="element-581">
                Sign In
              </Link>}
          </div>
        </div>}
    </header>;
};
export default Header;